<template>
  <div class="mask">
    <div class="content confirm">
      <h1>友情提示</h1>
      <p><slot></slot></p>
      <div style="text-align: center;">
        <button class="btn_cancel" @click="ensureCancel">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { order } from '@/apis'
  export default {
    data(){
      return {
        reqIsComplete:true,
        orderNo:this.$route.query.orderNo,
        errMsg:'',
        resultFlag:false
      }
    },
    props:['sendData','resumeCancelNum','timeOver'],
    computed:mapState({
      openid: state => state.openid,
      patientId: state => state.patientId,
      patientUUID: state => state.patientUUID,
    }),
    methods:{
      // 确认跳转医生列表
      ensureCancel(){
        this.$router.push({
          path:'/applyIndex'
        })
      },
      isCancel(data){
        this.$emit('isCancelStatus',data);
      }
    }
  }
</script>

<style scoped lang="scss">
  .mask{
    position:absolute;
    left:0;
    top:0;
    z-index:100;
    background:rgba(0,0,0,.5);
    @include width_height_100();
    .confirm{
      background:$bgfff;
      width:270px;
      height:168px;
      border-radius:3px;
      margin:185px auto 0 auto;
      h1{
        height:52px;
        line-height: 52px;
        @include text_font('PingFangSC',17px,550,#333,center);
      }
      p{
        width:230px;
        height:50px;
        line-height: 25px;
        margin:0 auto;
        @include text_font('PingFangSC',17px,normal,#666,center);
      }
      div{
        width:270px;
        height:45px;
        margin-top:20px;
        border-top:1px solid #F0F0F0;
        @include layout_row_root();
        button{
          width:134.5px;
          height:45px;
          line-height:45px;
          border:none;
          background:$bgfff;
          @include layout_row();
          @include text_font('PingFangSC',15px,normal,#999,center);
        }
        .btn_confirm{
          border-right:1px solid #F0F0F0;
        }
        .btn_cancel{
          color:#41B7A7;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MaskTempToast.vue